<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1 pb-2 ziro-datatable-content">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item [aboutCardId]="49"></ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>
    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

    @if (!isLoading) {
      <ziro-datatable
        [dataAutomation]="'port-in-number-status-datatable'"
        [columns]="datatableCols"
        [rowDataSource]="datatableRows"
        [uniqueRowIdentifier]="'phoneNumber'"
        [mainFilterPlaceholder]="
          'tkey;admin.order_numbers.port_in_number_status.datatable.filter_placeholder' | translate
        "
        [maxLength]="150"
        [stickyColumnCount]="1"
        [setColumnWidths]="false"
        [noResultsAlert]="
          !datatableRows.length
            ? ('tkey;admin.order_numbers.port_in_number_status.datatable.no_results' | translate)
            : ''
        "
        [noResultsAlertClass]="!datatableRows.length ? 'alert-light' : ''"
        [persistFilters]="true"
        [matchesSecondaryDataFn]="matchesSecondaryDataFn"
        [class]="'ziro-card'"
      >
        <ziro-datatable-date-filter
          [label]="'tkey;admin.order_numbers.port_in_number_status.datatable.foc_date.label'"
          [matchFn]="isDateMatchFn"
          [dataAutomation]="'foc-date-filter'"
          [tableId]="'port-in-number-status-datatable'"
        ></ziro-datatable-date-filter>
        <ziro-datatable-multi-select-filter
          [label]="'tkey;admin.order_numbers.port_in_number_status.datatable.sbc_configuration.label'"
          [items]="sbcConfigurationOptions"
          [matchFn]="isSbcConfigurationMatchFn"
          [labelCssClass]="'text-capitalize'"
          [dataAutomation]="'sbc-configuration-filter'"
          [tableId]="'port-in-number-status-datatable'"
        ></ziro-datatable-multi-select-filter>
        <ziro-datatable-multi-select-filter
          [label]="'tkey;admin.order_numbers.port_in_number_status.datatable.order_status.label'"
          [items]="orderStatusOptions"
          [matchFn]="isOrderStatusMatchFn"
          [labelCssClass]="'text-capitalize'"
          [dataAutomation]="'order-status-filter'"
          [tableId]="'port-in-number-status-datatable'"
        ></ziro-datatable-multi-select-filter>
      </ziro-datatable>
    }
  </div>
</div>
